import { useState } from "react";
import { useCastle } from "../api/castle";
import { useMe } from "../api/army";
import { Loading } from "./Loading";
import { ResourceBar } from "../components/ResourceBar";
import { ScreenBanner } from "../components/ScreenBanner";
import { ProfileView } from "../components/ProfileView";
import { LeaderboardView } from "../components/LeaderboardView";
import { EventsView } from "../components/EventsView";
import { ShopScreen } from "./ShopScreen";
import { BattlePassScreen } from "./BattlePassScreen";

type Sub = "profile" | "shop" | "pass" | "leaderboard" | "events";

interface TabDef {
  id: Sub;
  label: string;
}

// Inventory and Alliance graduated to top-level bottom-nav tabs (2026-05-23).
// MeScreen retains the meta/social sub-tabs that don't need a permanent
// bottom slot: profile stats, shop, leaderboard, events.
const tabs: TabDef[] = [
  { id: "profile", label: "Профиль" },
  { id: "shop", label: "Магазин" },
  { id: "pass", label: "Пропуск" },
  { id: "leaderboard", label: "Топ" },
  { id: "events", label: "События" },
];

export function MeScreen() {
  const castle = useCastle();
  const me = useMe();
  const [sub, setSub] = useState<Sub>("profile");

  if (castle.isPending || me.isPending) {
    return <Loading message="Окно «Я» открывается..." />;
  }
  const data = castle.data!;

  return (
    <div className="flex h-full flex-col">
      <ScreenBanner kind="profile" title="Я" subtitle={me.data?.displayName ?? ""} />
      <ResourceBar resources={data.state.resources} safeStorage={data.safeStorage} />

      <div className="grid grid-cols-5 gap-1 px-2 pt-2">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setSub(t.id)}
            className={`rounded-lg py-2 text-xs ${
              sub === t.id ? "bg-tg-button text-tg-buttonText" : "bg-tg-secondaryBg text-tg-hint"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-2 flex-1 overflow-y-auto">
        {sub === "profile" && <ProfileView enabled />}
        {sub === "shop" && <ShopScreen embedded />}
        {sub === "pass" && <BattlePassScreen embedded />}
        {sub === "leaderboard" && <LeaderboardView enabled />}
        {sub === "events" && (
          <EventsView enabled isTestWorld={me.data?.isTestWorld ?? false} />
        )}
      </div>
    </div>
  );
}
